<template>
  <Layout>
    <div class="top-actions">
      <div class="row">
        <div class="col-8">
          <div class="flex justify-start">
            <q-btn color="blue" @click="$router.push({name: 'blackbook'})">
              <template>
                <div>
                  <q-icon name="fas fa-arrow-left" class="q-mr-sm"/>
                  <span class="q-gutter-md">
                    <span>Back to vehicle list</span>
                  </span>
                </div>
              </template>
            </q-btn>
          </div>
        </div>
        <div class="col-4">
          <div class="flex justify-end">
            <q-btn-dropdown color="grey" icon="fas fa-filter">
              <q-form @submit.prevent.stop="handleHistoryFilter" class="q-pa-md" style="width: 260px;">
                <q-select
                  outlined
                  class="q-mb-md"
                  color="grey-7"
                  label-color="grey-7"
                  label="Result"
                  :options="results"
                  v-model="historyFilter.result"
                  emit-value
                  map-options
                  lazy-rules
                  dense
                  clearable>
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-italic text-grey">
                        There is no options.
                      </q-item-section>
                    </q-item>
                  </template>
                </q-select>
                <q-select
                  outlined
                  class="q-mb-md"
                  color="grey-7"
                  label-color="grey-7"
                  label="Is paid?"
                  :options="is_paid"
                  v-model="historyFilter.is_paid"
                  emit-value
                  map-options
                  lazy-rules
                  dense
                  clearable>
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-italic text-grey">
                        There is no options.
                      </q-item-section>
                    </q-item>
                  </template>
                </q-select>
                <q-select
                  outlined
                  class="q-mb-md"
                  color="grey-7"
                  label-color="grey-7"
                  label="Is completed?"
                  :options="is_completed"
                  v-model="historyFilter.is_completed"
                  emit-value
                  map-options
                  lazy-rules
                  dense
                  clearable>
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-italic text-grey">
                        There is no options.
                      </q-item-section>
                    </q-item>
                  </template>
                </q-select>
                <q-btn type="submit" color="primary" label="Filter" class="full-width"/>
              </q-form>
            </q-btn-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <q-card style="padding: 15px" v-if="items.length === 0 && !isLoading">
        <empty-value name="vehicle"></empty-value>
      </q-card>

      <div class="content-table scroll scroll-content" ref="table" v-else>
        <div v-if="items.length > 0">
          <q-btn
            v-if="items.length > 0"
            class="glossy custom-item-icon-3 left-0"
            style="margin-left: -10px"
            @mousedown="shiftLeft()"
            @mouseup="shiftLeftEnd()"
            round
            color="primary"
            icon="fas fa-arrow-left"
          />
          <q-btn
            v-if="items.length > 0"
            class="glossy custom-item-icon-3 right-0"
            @mouseup="shiftRightEnd()"
            @mousedown="shiftRight()"
            round
            color="primary"
            icon="fas fa-arrow-right"
          />
          <table>
            <thead>
            <tr>
              <th v-for="column in columns">{{ column.name }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in items" :key="item.id">
              <td v-for="column in columns" v-if="column.visible">
                <div v-if="column.val === 'selection'">
                  <q-btn round size="sm"
                         :color="selectedHistoryItems.some(i => i.vehicle.vin === item.vehicle.vin) ? 'green' : 'grey'"
                         @click.native="toggleSelectedItem(item)">
                    <template v-slot:default>
                      <q-icon name="fas fa-check"
                              v-if="selectedHistoryItems.some(i => i.vehicle.vin === item.vehicle.vin)"/>
                    </template>
                  </q-btn>
                </div>
                <div v-else-if="column.val === 'unit'">{{ item.vehicle.unit }}</div>
                <div v-else-if="column.val === 'result'">
                  <q-badge :color="getResultColor(item.result)">
                    {{ item.result.toUpperCase() }}
                    <q-tooltip v-if="item.message !== null">
                      <div>{{ item.message }}</div>
                    </q-tooltip>
                  </q-badge>
                </div>
                <div v-else-if="column.val === 'vehicles'">{{ item.items.length }}</div>
                <div v-else-if="column.val === 'amount'">{{ item.amount | toCurrency }}</div>
                <div v-else-if="column.val === 'paid_at'">
                  <div v-if="item[column.val] === null">
                    <q-btn color="secondary"
                           size="sm"
                           class="btn q-mr-sm"
                           @click="$router.push({name: 'blackbook_show',
                           params: {id: item.id}, query: {payment: true}})">
                      <template>
                        <div>
                          <q-icon name="fas fa-lock" class="q-mr-sm" style="font-size: 10px;"/>
                          <span class="q-gutter-md">
                      <span>Secure Payment</span>
                    </span>
                        </div>
                      </template>
                    </q-btn>
                    <q-tooltip>
                      <div>Secure payment</div>
                    </q-tooltip>
                  </div>
                  <q-chip square color="green" text-color="white" v-else>Paid</q-chip>
                </div>
                <div v-else-if="column.val === 'completed_at'">
                  <span v-if="item[column.val] === null">-</span>
                  <span v-else>{{ item[column.val] | dateTimeFormat }}</span>
                </div>
                <div v-else-if="column.val === 'created_at'">
                  <span>{{ item[column.val] | dateTimeFormat }}</span>
                </div>
                <div v-else-if="column.val === 'actions'">
                  <q-btn round color="primary" size="sm" class="q-mr-sm"
                         @click="$router.push({name: 'blackbook_show', params: {id: item.id}})">
                    <q-tooltip>
                      <div>Show</div>
                    </q-tooltip>
                    <q-icon name="fas fa-eye"/>
                  </q-btn>
                </div>
                <div v-else>{{ item[column.val] }}</div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="loading-infinite" v-if="isLoading">
          <div>
            <q-spinner-facebook color="primary" size="40px"/>
            <div class="text-grey-7">Loading</div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "@/axios";
import {VMoney} from "v-money";
import EmptyValue from "@/components/EmptyValue.vue";
import Layout from "@/components/Layout.vue";

export default {
  name: 'History',
  components: {Layout, EmptyValue},
  props: {},
  data() {
    return {
      isLoading: true,
      companies: [],
      columns: [],
      results: [
        {
          label: 'Ready',
          value: 'ready'
        },
        {
          label: 'Success',
          value: 'success'
        },
        {
          label: 'Failed',
          value: 'failed'
        }
      ],
      is_paid: [
        {
          label: 'Yes',
          value: true
        },
        {
          label: 'No',
          value: false
        }
      ],
      is_completed: [
        {
          label: 'Yes',
          value: true
        },
        {
          label: 'No',
          value: false
        }
      ],
      per: 100,
      page: 1,
      lastPage: 1,
      items: [],
    }
  },
  computed: {
    historyListColumns: {
      get() {
        return this.$store.state.blackbook.historyListColumns;
      },
      set(val) {
        this.$store.commit("blackbook/SET_HISTORY_LIST_COLUMNS", val);
      },
    },
    historyFilter: {
      get() {
        return this.$store.state.blackbook.historyFilter;
      },
      set(val) {
        this.$store.commit("blackbook/SET_HISTORY_FILTER", val);
      },
    },
    selectedHistoryItems: {
      get() {
        return this.$store.state.blackbook.selectedHistoryItems;
      },
      set(val) {
        this.$store.commit("blackbook/SET_SELECTED_HISTORY_ITEMS", val);
      },
    },
  },
  async mounted() {
    const el = document.querySelector('.scroll-content')
    setTimeout(() => {
      el?.addEventListener('scroll', this.onScroll)
    }, 1000)
    this.selectedHistoryItems = []
    await this.getItems()
  },
  destroyed() {
    const el = document.querySelector('.scroll-content')
    el?.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    shiftRight() {
      this.rightInterval = setInterval(() => {
        this.$refs.table.scrollLeft += 50
      }, 50)
    },
    shiftRightEnd() {
      clearInterval(this.rightInterval)
    },
    shiftLeft() {
      this.leftInterval = setInterval(() => {
        this.$refs.table.scrollLeft -= 50
      }, 50)
    },
    shiftLeftEnd() {
      clearInterval(this.leftInterval)
    },
    async getItems() {
      const params = {
        per: this.per,
        page: this.page,
      }
      if (this.historyFilter.result !== null) {
        params.result = this.historyFilter.result
      }
      if (this.historyFilter.is_paid !== null) {
        params.is_paid = this.historyFilter.is_paid
      }
      if (this.historyFilter.is_completed !== null) {
        params.is_completed = this.historyFilter.is_completed
      }

      this.isLoading = true
      const {data} = await axios.get('/blackbook', {params})
      this.lastPage = data.data.pagination.last

      let deep = () => {
        if (this.page === 1) {
          return data.data.items.map(item => item)
        } else {
          let carbon = [...this.items]
          let nextPage = data.data.items.map(item => item)
          return carbon.concat(nextPage)
        }
      }
      this.items = deep()
      this.isLoading = false
    },
    async onScroll(e) {
      const obj = e.target
      if (e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight && this.items.length !== 0 &&
        !this.isLoading && this.page < this.lastPage) {
        this.page++
        await this.getItems()
      }
    },
    toggleSelectedItem(item) {
      const index = this.selectedHistoryItems.findIndex(vehicle => vehicle.vehicle.vin === item.vehicle.vin)
      if (index === -1) {
        this.selectedHistoryItems.push(item)
      } else {
        this.selectedHistoryItems.splice(index, 1)
      }
    },
    handleHistoryFilter() {
      this.historyFilter.changed = true
    },
    getResultColor(val) {
      if (val === 'success') {
        return 'green';
      } else if (val === 'failed') {
        return 'red';
      } else {
        return 'grey';
      }
    }
  },
  watch: {
    historyListColumns: {
      deep: true,
      immediate: true,
      handler(columns) {
        this.columns = columns.filter(col => col.visible)
      }
    },
    historyFilter: {
      deep: true,
      immediate: true,
      async handler(val) {
        if (val.changed) {
          val.changed = false
          this.page = 1
          this.items = []
          await this.getItems()
        }
      }
    },
    isSaveVehicles: {
      deep: true,
      immediate: true,
      async handler(val) {
        if (val) {
          this.isSaveVehicles = false
          const valid = await this.$refs.saveVehiclesFormRef.validate()
          if (valid) {
            await this.postSellVehicles()
          }
        }
      }
    },
  },
  directives: {money: VMoney},
}
</script>

<style scoped lang="scss">
.custom-item-icon-3 {
  z-index: 999 !important;
  position: fixed !important;
  top: 60% !important;
}

.right-0 {
  right: 0;
}

.table-cell {
  display: table-cell;
}

.none-cell {
  display: none;
}

.selected-finance {
  background: rgba(244, 67, 54, 0.5) !important;
}

.no-finance {
  background: rgba(244, 67, 54, 0.1) !important;
}

.tag-table-container {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;

  .tag-item {
    margin-right: -5px;
    height: 30px;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    border-radius: 50%;
  }
}

.mark-table {
  background: rgba(0, 0, 0, 0.12) !important;
}

.flip-list-move {
  transition: transform 500ms;
}

.content-table {
  position: relative;
  width: 100%;
  max-height: calc(100vh - 215px)
}

.content-table table {
  min-width: auto !important;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
}

.table-wrap {
  position: relative;
}

.content-table {
  th {
    align-items: center;
    padding: 15px 5px;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    vertical-align: center;
    text-align: center;
  }

  td {
    padding: 15px 10px;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    vertical-align: center;
    text-align: center;
    cursor: auto;
  }
}

@media only screen and (max-width: 600px) {
  .content-table th,
  .content-table td {
    padding: 15px 5px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    vertical-align: center;
    text-align: left;
  }
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.container-checkbox {
  width: 18px;
  cursor: pointer;
  height: 18px;
  text-align: center;
  border: 2px solid rgba(0, 0, 0, 0.54);
}

.input-col {
  padding: 30px 10px 10px !important;
}

.fix-col {
  min-width: 100px;
}

.fix-col-lg {
  min-width: 130px;
}

.fix-col-xl {
  min-width: 170px;
}

.box {
  position: relative;
  margin-top: 50px;
  width: 100%;
  max-height: calc(100vh - 240px)
}

.top-actions {
  position: absolute;
  top: 10px;
  right: 0;
  padding: 10px 25px;
  width: 100%;
  height: 60px;

  .selection {
    margin: 8px 15px 0;
  }

  .q-btn {
    .q-icon {
      font-size: 14px;
    }
  }
}
</style>
